<template>
  <div class="year-month-picker" style="position: relative; display: inline-block; width: 100px;">
    <!-- 使用 a-input 保持风格统一 -->
    <a-input
      :value="displayValue"
      readonly
      placeholder="请选择年月"
      @click="togglePicker"
      @blur="handleBlur"
    >
      <!-- <template #suffix>
        <calendar-outlined />
      </template> -->
    </a-input>

    <!-- 下拉面板 -->
    <div
      v-if="visible"
      ref="panel"
      class="year-month-panel"
      @mousedown.prevent
    >
      <!-- 年份控制 -->
      <div class="year-header">
        <a-button size="small" @click="prevYear">«</a-button>
        <span class="year-text">{{ currentYear }}</span>
        <a-button size="small" @click="nextYear">»</a-button>
      </div>

      <!-- 月份列表 -->
      <div class="month-grid">
        <div
          v-for="month in 12"
          :key="month"
          class="month-item"
          :class="{ 'month-item-selected': isSelected(month) }"
          @click="selectMonth(month)"
        >
          {{ getMonthName(month) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { CalendarOutlined } from '@ant-design/icons-vue'
// import { Button, Input } from 'ant-design-vue'

export default {
  name: 'YearMonthPicker',
  // components: {
  //   CalendarOutlined,
  //   AInput: Input,
  //   AButton: Button
  // },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      currentYear: new Date().getFullYear(),
      selectedYear: null,
      selectedMonth: null
    }
  },
  computed: {
    displayValue() {
      if (this.value) {
        const [y, m] = this.value.split('-')
        this.currentYear = parseInt(y)
        this.selectedYear = y
        this.selectedMonth = parseInt(m)
        return `${y}-${m.padStart(2, '0')}`
      }
      return ''
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        const [y, m] = newVal.split('-')
        this.selectedYear = y
        this.selectedMonth = parseInt(m)
        this.currentYear = parseInt(y)
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    getMonthName(month) {
      const names = ['一月', '二月', '三月', '四月', '五月', '六月',
                    '七月', '八月', '九月', '十月', '十一月', '十二月']
      return names[month - 1]
    },
    togglePicker() {
      this.visible = !this.visible
    },
    handleBlur() {
      // 不立即关闭，由 outside click 控制
    },
    handleOutsideClick(event) {
      if (this.visible && !this.$el.contains(event.target)) {
        this.visible = false
      }
    },
    prevYear() {
      this.currentYear--
    },
    nextYear() {
      this.currentYear++
    },
    selectMonth(month) {
      const formattedMonth = month.toString().padStart(2, '0')
      const result = `${this.currentYear}-${formattedMonth}`
      this.$emit('input', result)
      this.$emit('change', result)
      this.visible = false
    },
    isSelected(month) {
      return (
        this.selectedYear === this.currentYear.toString() &&
        this.selectedMonth === month
      )
    }
  }
}
</script>

<style scoped>
.year-month-panel {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1050;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
              0 6px 16px 0 rgba(0, 0, 0, 0.08),
              0 9px 28px 8px rgba(0, 0, 0, 0.05);
  padding: 8px;
  width: 220px;
}

.year-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.year-text {
  font-weight: bold;
  font-size: 14px;
}

.month-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}

.month-item {
  padding: 4px 0;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.3s;
}

.month-item:hover {
  background-color: #f0f0f0;
}

.month-item-selected {
  background-color: #e6f7ff;
  color: #1890ff;
  font-weight: bold;
}
</style>